<template>
  <v-container fluid>
    <div v-if="carregando">
      <div class="mt-2 text-center" v-for="i in 3" :key=i>
        <v-skeleton-loader type="list-item" class="mb-2"></v-skeleton-loader>
        <v-skeleton-loader type="image"></v-skeleton-loader>
      </div>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        {{contato.cli_nome}}
      </div>
      <v-tabs
        next-icon="chevron_right"
        prev-icon="chevron_left"
        show-arrows
        class="ui-tabs"
        v-model="tabs">
        <v-tab>
          <v-icon>account_circle</v-icon> Dados
        </v-tab>
        <v-tab>
          <v-icon>trending_up</v-icon> Oportunidades
        </v-tab>
      </v-tabs>
      <v-tabs-items v-model="tabs">
        <v-tab-item class="px-1 pb-1">
          <v-card class="px-6 py-5">
            <v-row>
              <v-col cols="12" md="6">
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_tipo">
                  <b>Tipo:</b> {{contato.cli_tipo === 1 ? 'Pessoa Física' : 'Pessoa Jurídica'}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_telefone">
                  <b>Telefone:</b> {{contato.cli_telefone}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_celular">
                  <b>Celular:</b> {{contato.cli_celular}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_email">
                  <b>E-mail:</b> {{contato.cli_email}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_nascimento">
                  <b>Data de nascimento:</b> {{formatDate(contato.cli_nascimento)}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_detalhes">
                  <b>Detalhes:</b> {{contato.cli_detalhes}}
                </div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_rua">
                  <b>Logradouro:</b> {{contato.cli_rua}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_numero">
                  <b>Número:</b> {{contato.cli_numero}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_bairro">
                  <b>Bairro:</b> {{contato.cli_bairro}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_cep">
                  <b>CEP:</b> {{contato.cli_cep}}
                </div>
                <div class="text-h3 text--thin mb-1" v-if="contato.cli_cidade || contato.cli_uf">
                  <b>Cidade:</b> {{contato.cli_cidade + '/' + contato.cli_uf}}
                </div>
                <div v-if="contato.cli_complemento" class="text-h3 text--thin mb-1">
                  <b>Complemento:</b> {{contato.cli_complemento}}
                </div>
              </v-col>
              <v-col cols="12">
                <v-btn
                  color="cancel"
                  :disabled="salvando"
                  :loading="salvando"
                  @click="$router.push({name: 'Contatos'}).catch(() => {})"
                >
                  Voltar
                </v-btn>
                <v-btn
                  color="warning"
                  class="ml-2"
                  @click="dialogDelete = true"
                  :loading="salvando"
                  :disabled="salvando"
                >
                  Remover contato
                </v-btn>
              </v-col>
            </v-row>
          </v-card>
        </v-tab-item>
        <v-tab-item class="px-1 pb-1">
          <lista-oportunidades :cliente="contato.uuid_cli_id"></lista-oportunidades>
        </v-tab-item>
      </v-tabs-items>
      <v-dialog v-model="dialogDelete" max-width="400">
        <v-card class="ui-dialog-top">
          <v-row align="center" justify="space-between">
            <v-col cols="10">
              Remover Contato
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon @click="dialogDelete = false">close</v-icon>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="ui-dialog-content">
          <div class="text-h3 mb-5">
            Tem certeza que deseja remover este contato?
          </div>
          <v-divider class="mb-3"></v-divider>
          <v-row
            align="center"
            justify="space-between"
            class="px-5 py-5"
          >
            <v-btn
              color="cancel"
              :loading="salvando"
              :disabled="salvando"
              @click="dialogDelete = false"
            >
              Cancelar
            </v-btn>
            <v-btn
              color="success"
              :loading="salvando"
              :disabled="salvando"
              @click="removeContato()"
            >
              Remover
            </v-btn>
          </v-row>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
import moment from 'moment'
import ListaOportunidades from '../oportunidades/ListaOportunidades.vue'

export default {
  components: {
    ListaOportunidades
  },
  data () {
    return {
      tabs: 0,
      carregando: true,
      salvando: false,
      dialogDelete: false,
      contato: {}
    }
  },
  methods: {
    async getContato () {
      this.carregando = true
      await Api.get(`clientes/${this.$route.params.uuid}`)
        .then(res => {
          if (res.data) {
            this.contato = res.data
            console.log(res.data)
          }
          this.carregando = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar o contato!',
            color: 'error'
          })
          console.log(err)
        })
    },
    removeContato () {
      this.salvando = true
      Api.delete(`clientes/remove/${this.contato.uuid_cli_id}`)
        .then(res => {
          this.$root.SnackControl.open(this, {
            text: res.data.msg
          })
          this.salvando = false
          this.dialogDelete = false
          this.$router.push({name: 'Contatos'}).catch(() => {})
        })
        .catch(err => {
          console.log(err)
          this.salvando = false
          this.$root.SnackControl.open(this, {
            text: err.response ? err.response.data.message : 'Erro ao remover contato!',
            color: 'error'
          })
        })
    },
    formatDate (date) {
      return moment(date).format('L')
    },
    loadFunctions () {
      this.getContato()
    },
    loadContent () {
      this.loadFunctions()
    }
  },
  created () {
    this.loadContent()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
>>>.v-tabs-items {
  min-height: inherit!important;
}
</style>



// WEBPACK FOOTER //
// src/pages/contatos/Contato.vue